import { useModal } from "@/components/_primitives/Modal/ModalRoot/ModalRoot";
import { useAppContext } from "@/context/AppContext";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { useGrid } from "../Grid";
import { useRouter } from "next/router";
import { StandardCategoryType } from "@/utils/rezeptAPI/getRecipeFilterOptions";
import { updateQueryParamsFromFilters } from "@/modules/RecipeGrid/queryParamsHelper";
import styles from "./GridFilterSection.module.scss";
import { Button } from "@/components/Global/Button/Button";
import { ReactSVG } from "react-svg";
import { cleanTipTopfFilterLabel } from "@/utils/stringManipulation";

export const GridFilterSection = ({
  filterOptions,
}: {
  filterOptions: StandardCategoryType[];
}) => {
  const { setOpen } = useModal();
  const { getLabel } = useGlobalContext();
  const { setFormModalType } = useAppContext();
  const { filters } = useGrid();
  const router = useRouter();

  const activeFilters = filterOptions.filter((option) =>
    filters.categories.includes(option.kategorie_id),
  );

  const handleDelete = (
    options: { type: "one"; id: number } | { type: "all" },
  ) => {
    const newFilters = { ...filters };

    if (options.type === "all") {
      newFilters.categories = [];
      newFilters.difficultyLevel = null;
    } else {
      const { categories } = newFilters;
      const indexOfCategorie = categories.indexOf(options.id);
      if (indexOfCategorie > -1) categories.splice(indexOfCategorie, 1);
    }

    updateQueryParamsFromFilters(newFilters, router);
  };

  const handleModalOpen = () => {
    setFormModalType("recipe-filter");
    setOpen(true);
  };

  return (
    <>
      <Button
        type="primary"
        href="#"
        target=""
        onClick={handleModalOpen}
        icon={"circleFilter"}
      >
        {getLabel("recipe_filter_modal_button_label")}
      </Button>

      <section className={styles["filter-badge-wrapper"]}>
        {activeFilters.map((filter) => (
          <FilterBadge
            key={`card-${filter.kategorie_id}`}
            label={filter.kategorie_titel}
            onClick={() =>
              handleDelete({ type: "one", id: filter.kategorie_id })
            }
          />
        ))}
      </section>

      {activeFilters.length > 0 && (
        <Button
          type="secondary"
          href="#"
          target=""
          onClick={() => handleDelete({ type: "all" })}
          icon={"circleArrowRight"}
          className={styles["reset-button"]}
        >
          {getLabel("recipe_filter_reset_button_label")}
        </Button>
      )}
    </>
  );
};

type FilterBadgeProps = {
  label: string;
  onClick: () => void;
};

const FilterBadge = ({ label, onClick }: FilterBadgeProps) => {
  const { getIcon } = useGlobalContext();

  return (
    <div className={styles["filter-badge"]}>
      <p>{cleanTipTopfFilterLabel(label)}</p>
      <button type="button" onClick={onClick}>
        <ReactSVG
          src={getIcon("minus")}
          width={20}
          height={20}
          wrapper="svg"
          aria-hidden
        />
      </button>
    </div>
  );
};
